import { render, staticRenderFns } from "./AISpotlight.vue?vue&type=template&id=0e2e46cd&scoped=true"
import script from "./AISpotlight.vue?vue&type=script&lang=js"
export * from "./AISpotlight.vue?vue&type=script&lang=js"
import style0 from "./AISpotlight.vue?vue&type=style&index=0&id=0e2e46cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e46cd",
  null
  
)

export default component.exports